// eslint-disable-next-line @typescript-eslint/no-empty-function
const EMPTY_FUNCTION = () => {};
const DI_DEFAULT_COMPARE = (value1, value2) => value1 === value2;

/**
 * Generated bundle index. Do not edit.
 */

export { DI_DEFAULT_COMPARE, EMPTY_FUNCTION };
